import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, Link } from '@mui/material';
// hooks
import useOffSetTop from '../../../hooks/useOffSetTop';
import useResponsive from '../../../hooks/useResponsive';
// utils
import cssStyles from '../../../utils/cssStyles';
// config
import { HEADER, NAVBAR } from '../../../config';
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import Logo from '../../../components/Logo';
import Iconify from '../../../components/Iconify';
import { IconButtonAnimate } from '../../../components/animate';
//
import AccountPopover from './AccountPopover';
import NotificationsPopover from './NotificationsPopover';

// ----------------------------------------------------------------------

const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isCollapse' && prop !== 'isOffset' && prop !== 'verticalLayout',
})(({ isCollapse, isOffset, verticalLayout, theme }) => ({
  backgroundColor: '#FFF',
  boxShadow: 'none',
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  transition: theme.transitions.create(['width', 'height'], {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('lg')]: {
    height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH + 1}px)`,
    ...(isCollapse && {
      width: `calc(100% - ${NAVBAR.DASHBOARD_COLLAPSE_WIDTH}px)`,
    }),
    ...(isOffset && {
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
    }),
    ...(verticalLayout && {
      width: '100%',
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
      backgroundColor: theme.palette.background.default,
    }),
  },
}));

// ----------------------------------------------------------------------

DashboardHeader.propTypes = {
  onOpenSidebar: PropTypes.func,
  isCollapse: PropTypes.bool,
  verticalLayout: PropTypes.bool,
};

export default function DashboardHeader({ onOpenSidebar, isCollapse = false, verticalLayout = false }) {
  const isOffset = useOffSetTop(HEADER.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;

  const isDesktop = useResponsive('up', 'lg');


  return (
    <RootStyle isCollapse={isCollapse} isOffset={isOffset} verticalLayout={verticalLayout} sx={{ bgcolor: '#FFF', borderBottom: '1px solid #F1F5F9' }}>
      <Toolbar
        sx={{
          minHeight: '100% !important',
          px: { lg: 5 },
        }}
      >
        {/* Logo removed from header on desktop to prevent duplication with sidebar */}

        {!isDesktop && (
          <IconButtonAnimate onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
            <Iconify icon="eva:menu-2-fill" />
          </IconButtonAnimate>
        )}

        {isDesktop && (
          <Stack direction="row" spacing={3} sx={{ flexGrow: 1, justifyContent: 'center' }}>
            <Link component={RouterLink} to={PATH_DASHBOARD.general.app} sx={{ color: 'text.primary', fontWeight: 700, textDecoration: 'none' }}>Home</Link>
            <Link component={RouterLink} to={PATH_DASHBOARD.general.buydata} sx={{ color: 'text.secondary', fontWeight: 600, textDecoration: 'none' }}>Data</Link>
            <Link component={RouterLink} to={PATH_DASHBOARD.general.buyairtime} sx={{ color: 'text.secondary', fontWeight: 600, textDecoration: 'none' }}>Airtime</Link>
            <Link component={RouterLink} to={PATH_DASHBOARD.general.exam} sx={{ color: 'text.secondary', fontWeight: 600, textDecoration: 'none' }}>Edu PIN</Link>
            <Link component={RouterLink} to={PATH_DASHBOARD.user.account} sx={{ color: 'text.secondary', fontWeight: 600, textDecoration: 'none' }}>My accounts</Link>
          </Stack>
        )}

        {!isDesktop && <Box sx={{ flexGrow: 1 }} />}

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
          <NotificationsPopover />
          <AccountPopover />
        </Stack>
      </Toolbar>
    </RootStyle>
  );
}
